import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

import PathElement from "../../../../../../server/com/silkplm/engine/audit/path/PathElement.js";
let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.engine.audit.path.ListIndex';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class ListIndex extends PathElement {

    /**
     *  @class ListIndex
     *  @alias module:src/server/com/silkplm/engine/audit/path/ListIndex.ListIndex
     *  
     * */
    constructor(){
        super();

        /** @type {number}  */
        this.idx = null;
        /** @type {string}  */
        this.l = null;
        /** @type {string}  */
        this.t = null;

    }





    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/audit/path/ListIndex.ListIndex}
     */
    withIdx(val){
        this.idx = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/audit/path/ListIndex.ListIndex}
     */
    withL(val){
        this.l = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/audit/path/ListIndex.ListIndex}
     */
    withT(val){
        this.t = val;
        return this;
    };





    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['idx'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['l'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['t'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.engine.audit.path.ListIndex';
metadata.__type_short__ = 'ListIndex';
ListIndex.prototype.__metadata__ = metadata;

ListIndex.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/engine/audit/path/ListIndex */
export default ListIndex

export { ListIndex }
